import React from "react";
import { CheckIcon, GlobeIcon, LockIcon, FlameIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { offerItems, offerPerks } from "../data/content";
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function Offer() {
  const filled = (TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100;
  return <section id="offer" className="w-full bg-canvas px-4 py-16 sm:px-5 sm:py-20" data-id="element-182" data-mp="1hqs749kvfpl4">
      <div className="mx-auto max-w-2xl overflow-hidden rounded-3xl border-4 border-brand bg-white shadow-[0_30px_60px_-25px_rgba(10,26,54,0.45)]" data-id="element-183" data-mp="u0xt3ootfuza">
        <div className="bg-brand px-5 py-5 text-center" data-id="element-184" data-mp="13xawxfe2rp7r">
          <p className="text-sm font-extrabold uppercase tracking-wider text-white/85" data-id="element-185" data-mp="13uoeultk5rba">Your Special Launch Offer</p>
          <h2 className="mt-1 font-display text-2xl font-black leading-tight text-white sm:text-3xl" data-id="element-186" data-mp="2fc6cr4ogjwpw">
            Here's Everything You'll Receive Today
          </h2>
        </div>

        <ul className="divide-y divide-navy/10 px-5 sm:px-8" data-id="element-187" data-mp="2affucap6kp1b">
          {offerItems.map(item => <li key={item.title} className="flex gap-3 py-4" data-id="element-188" data-mp="pml6pid8hbb7">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-189" data-mp="uhqt0iajsrzt">
                <CheckIcon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-190" data-mp="zj6e2acq6yi7" />
              </span>
              <div className="min-w-0 flex-1" data-id="element-191" data-mp="13j73sr59yw4k">
                <div className="flex items-start justify-between gap-3" data-id="element-192" data-mp="6u99fa1ft07x">
                  <h3 className="font-display text-base font-extrabold leading-snug text-navy" data-id="element-193" data-mp="6rwi469shdi7">{item.title}</h3>
                  <s className="shrink-0 text-sm font-bold text-alert" data-id="element-194" data-mp="fuffwbypwzxl">{item.value}</s>
                </div>
                <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-195" data-mp="kkvysblb5drc">{item.body}</p>
              </div>
            </li>)}
        </ul>

        <div className="bg-navy px-5 py-8 text-center sm:px-8" data-id="element-196" data-mp="3k847249mw0xt">
          <p className="text-base font-semibold text-white/70" data-id="element-197" data-mp="3o9fp9oq6hjvz">
            Total Reference Value: <s className="text-alert" data-id="element-198" data-mp="vf7dyi1mqicl">$254</s>
          </p>
          <p className="mt-2 text-sm font-extrabold uppercase tracking-wider text-gold" data-id="element-199" data-mp="vdnwwp85g39r">Today, get everything for just…</p>
          <p className="mt-1 font-display text-7xl font-black leading-none text-white sm:text-8xl" data-id="element-200" data-mp="155k6oxjllhtt">
            $27<span className="ml-1 text-2xl font-extrabold" data-id="element-201" data-mp="106h55n2tttql">USD</span>
          </p>
          <p className="mt-2 text-sm font-bold uppercase text-white/80" data-id="element-202" data-mp="108thnkptfbw9">One-time payment</p>
          <p className="mx-auto mt-4 flex max-w-sm items-center justify-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-medium text-white" data-id="element-203" data-mp="ciz6d7l59ve4">
            <GlobeIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-204" data-mp="lim85uhsd37p" />
            Currency converts automatically to yours at checkout
          </p>
        </div>

        <div className="px-5 py-8 sm:px-8" data-id="element-205" data-mp="1wwg9t6fuw83w">
          <ul className="grid gap-2.5 sm:grid-cols-2" data-id="element-206" data-mp="1wv54v3aocub7">
            {offerPerks.map(perk => <li key={perk} className="flex items-center gap-2 text-base font-medium text-navy" data-id="element-207" data-mp="1sul9o59nw0rp">
                <CheckIcon className="h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-208" data-mp="20d2molgqxxpf" />
                {perk}
              </li>)}
          </ul>

          <div className="mt-6 rounded-2xl border-2 border-alert/30 bg-alert-light p-4" data-id="element-209" data-mp="1qgpx9zs8i60h">
            <p className="flex items-center gap-2 text-base font-extrabold text-alert" data-id="element-210" data-mp="1vfkjlbpeucpc">
              <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-211" data-mp="1vhdsyyrerb11" />
              Only {SPOTS_LEFT} spots left at the promotional price!
            </p>
            <div className="mt-3 h-5 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-212" data-mp="2o2x1h8kmlwcb">
              <div className="scarcity-fill h-full rounded-full" style={{
              width: `${filled}%`
            }} data-id="element-213" data-mp="322oi7h2j1qu0" />
            </div>
            <p className="mt-2 text-sm font-semibold text-navy" data-id="element-214" data-mp="36wkducvbj1m0">
              {TOTAL_SPOTS - SPOTS_LEFT}% claimed — the price goes back up when the bar is full.
            </p>
          </div>

          <div className="mt-7" data-id="element-215" data-mp="1e9ec2m1t4cbx">
            <CtaButton shake note="One-Time Payment · Instant Download · 7-Day Money-Back Guarantee" data-id="element-216" data-mp="197owqu7jxci1">
              Yes! Give Me Instant Access for $27
            </CtaButton>
          </div>

          <div className="mt-8" data-id="element-217" data-mp="21wmg70ni1fcd">
            <Countdown label="This price expires in:" data-id="element-218" data-mp="21vulds1q7ln5" />
          </div>

          <p className="mt-6 flex items-center justify-center gap-2 text-sm text-muted" data-id="element-219" data-mp="1wx9h9hjcshtf">
            <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-220" data-mp="1s6t31v7pks60" />
            Secure checkout · Currency converted automatically where applicable
          </p>
        </div>
      </div>
    </section>;
}